"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuCommands = exports.menuReducer = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    loadingMessage: null,
};
_a = (0, toolkit_1.createSlice)({
    name: "menu",
    initialState,
    reducers: {
        setLoadingMessage: (state, action) => {
            state.loadingMessage = action.payload;
        },
        clearLoadingMessage: (state) => {
            state.loadingMessage = null;
        },
    },
}), exports.menuReducer = _a.reducer, exports.MenuCommands = _a.actions;
